import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import App from './App'

const lifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: App,
    errorBoundary(err, info, props) {
        return <div>Erro ao carregar aplicação Auth</div>
    },
})

export const { mount, unmount, bootstrap } = lifecycles
